import styled from 'styled-components'

export const Container = styled.div`
	
`

export const VisualizacaoContainer = styled.div`
	img, iframe {
		width: 100%;
	}

	iframe {
		height: 74vh;
	}
`
